import { combineReducers } from 'redux';
import { reducer as auth } from './slices/auth';
import { reducer as rent } from './slices/rent';
import { reducer as appConfig } from './slices/app-config';

const rootReducer = combineReducers({
    auth,
    rent,
    appConfig,
});

export default rootReducer;
